import z from 'zod';

import type { QcsResourceSlice } from '../core/resourceSliceUtils';

export const MILEAGE_TRACKER_ADDRESS_REDUCER_KEY = 'mileageTrackerAddressStore';
export type MILEAGE_TRACKER_ADDRESS_REDUCER_KEY = typeof MILEAGE_TRACKER_ADDRESS_REDUCER_KEY;

// The address a trip carried inside itself before trips referred to stored addresses by id. Older trips still have it.
export const MileageTrackerAddressSchema = z.object({
  id: z.string().optional(),
  clientId: z.string().optional(),
  createdAt: z.string().optional(),
  modifiedAt: z.string().optional(),
  name: z.string(),
  line1: z.string().optional(),
  line2: z.string().optional(),
  city: z.string().optional(),
  state: z.string().optional(),
  country: z.string().optional(),
  zipCode: z.string().optional(),
  isDeleted: z.boolean().optional(),
});

export type MileageTrackerAddressType = z.infer<typeof MileageTrackerAddressSchema>;

// One row of the address table, as GET /mileage/addresses returns it: an address the server stored when it was
// resolved. Trips refer to it by `id` (startAddressId / endAddressId). The app never changes or deletes them. It has no
// formatted text: that is built from the address parts (see formatAddress).
export const MileageTrackerAddressRecordSchema = z.object({
  id: z.string(),
  ownerId: z.string().optional(),
  deletedId: z.string().optional(),
  userModifiedAt: z.string().optional(),
  createdAt: z.string().optional(),
  modifiedAt: z.string().optional(),
  clientId: z.string().optional(),
  optLock: z.string().optional(),
  name: z.string().optional(),
  line1: z.string().optional(),
  line2: z.string().optional(),
  city: z.string().optional(),
  state: z.string().optional(),
  country: z.string().optional(),
  zipCode: z.string().optional(),
  hash: z.string().optional(),
  latitude: z.number().optional(),
  longitude: z.number().optional(),
});

export type MileageTrackerAddressRecord = z.infer<typeof MileageTrackerAddressRecordSchema>;
export type MileageTrackerAddressState = QcsResourceSlice<MileageTrackerAddressRecord>;

declare module 'app-components/utils/redux-store/rootState' {
  export default interface RootState {
    [MILEAGE_TRACKER_ADDRESS_REDUCER_KEY]: MileageTrackerAddressState;
  }
}
